<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['suggest']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <article
    class="grid gap-4 rounded-lais border border-lais-primary/20 bg-lais-primary-50/40 p-4 shadow-lais-card md:grid-cols-[48px_1fr_auto] md:items-center"
  >
    <span
      class="grid size-12 place-items-center rounded-full bg-white text-lais-primary"
      aria-hidden="true"
    >
      <span class="i-lucide-door-open size-6" />
    </span>
    <div class="min-w-0">
      <p class="text-[12px] font-semibold uppercase text-lais-primary">
        Indicação de imóvel
      </p>
      <h3 class="mt-1 text-[17px] font-semibold text-lais-text">
        Tem uma chave nova na carteira?
      </h3>
      <p class="mt-1 text-[13px] leading-relaxed text-lais-text-body">
        Indique o imóvel para o time operacional revisar acesso, proprietário e
        disponibilidade antes da primeira visita.
      </p>
    </div>
    <LaisPrimaryButton
      icon="i-lucide-send"
      :is-loading="loading"
      class="w-full md:w-auto"
      @click="emit('suggest')"
    >
      Indicar imóvel
    </LaisPrimaryButton>
  </article>
</template>
